<template>
  <section class="page-container">
    <div class="total">
      <div
        v-for="(value,i) in statistics"
        :key="i"
        class="item">
        <span class="num">{{value.val}}</span>
        <span>{{value.name}}</span>
      </div>
    </div>

    <div class="filter-card">
      <div class="filter-top">
        <span>Search</span>
        <v-input
          v-model="search"
          placeholder="Ref., Recipient, Phone No., Tracking No."
          @keyEnter="filterData" />
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <div class="flex-sb">
              <div class="form-half">
                <v-checkbox-group
                  v-model="status"
                  :list="statusList"
                  @change="filterData">
                  <template #default="{ item }">
                    <span class="flex-sb-center">
                      <span
                        class="circle"
                        :class="{
                          'yellow': item.id == 1,
                          'green': item.id == 2,
                        }"></span>
                      <span>{{ item['name'] }}</span>
                    </span>
                  </template>  
                </v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Product
              <span
                class="all"
                @click="handlerSelectAll('product_id')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('product_id')">None</span>
            </span>
            <div class="flex-sb">
              <div>
                <v-checkbox-group
                  v-model="product_id"
                  :list="productList"
                  @change="filterData">
                  <template #default="{ item }">
                    <span>{{ item['name'] }}</span>
                  </template>  
                </v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="shopping-bag"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
          label="Purchased">
          <template #default="{row}">
            <p>{{row.created_date}}</p>
            <p>{{row.created_time}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Product Name">
          <template #default="{row}">
            <div @click="rowClick(row)">
              <router-link
                :to="clickProductName(row)"
                class="no-line">
                <p class="product-name">{{row.product_nm}}</p>
                <p class="ref"><span>Reference</span>{{row.order_sn}}</p>
                <p class="ref"><span>Tracking No.</span>{{row.track_number}}</p>
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="85px"
          label="Amount"
          prop="buy_num">
        </el-table-column>
        <el-table-column
          width="85px"
          label="Price"
          prop="amount">
        </el-table-column>
        <el-table-column
          label="Recipient">
          <template #default="{ row }">
            <span class="break-word">{{row.isrd_nm}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          :show-overflow-tooltip="true"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p>
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': row.status == 1,
                    'green': row.status == 2,
                  }">
                  {{ row.status_language }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getIndicaidList, purchaseListExport} from '@/api/micropolicy'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
export default {
  name: 'PurchaseList',
  data () {
    return {
      search: null,
      date: [],
      status: [],
      statusList:[
        {
          id: 2,
          name: 'Shipped'
        },
        {
          id: 1,
          name: 'Preparing'
        }
      ],
      product_id:[],
      productList:[
        {
          id: 10,
          name: 'RightSign COVID-19 Antigen Rapid Test Cassette'
        },
        {
          id: 11,
          name: 'Longsee 2019-nCov Ag Rapid Detection Kit (Immuno-Chromatography)'
        },
      ],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total Orders',
          val: 0
        },
        total_buy_num: {
          name: 'Total Amount',
          val: 0
        },
        total_longsee_num: {
          name: 'Longsee Amount',
          val: 0
        },
        total_rightsign_num: {
          name: 'RightSign Amount',
          val: 0
        },
      }
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.selectFilterData||{}
        Object.keys(policy).forEach(item=>{
          this[item] = policy[item]
        })
        this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    }
  },
  created(){
    this.network().getList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },

    filterData(){
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productList'
          break
        case 'status':
          origin = 'statusList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },

    rowClick(row){
      let params = {
        date: this.date,
        page: this.pageConfig.currentPage,
        search: this.search,
        status: this.status,
        product_id: this.product_id
      }
      this.setFilterData({policy:params})
      this.$router.push({
        path: '/records/micropolicy/purchase-detail',
        query: {
          id: row.id
        }
      })
    },

    clickProductName(row){
      return ({
        path: '/records/micropolicy/purchase-detail',
        query: {
          id: row.id
        }
      })
    },

    handlerDown() {
      this.network().purchaseListExport()
    },

    network(){
      return {
        getList: async () => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            product_id: this.product_id
          }
          const { data } = await getIndicaidList(params)
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          this.tableData = data.data
          this.statistics.total.val = data.total
          this.statistics.total_buy_num.val = data.total_buy_num
          this.statistics.total_longsee_num.val = data.total_longsee_num
          this.statistics.total_rightsign_num.val = data.total_rightsign_num
        },

        purchaseListExport: async() => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            product_id: this.product_id
          }
          const res = await purchaseListExport(params)
          downloadFile(res)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.yellow {
        background: #DBAB09;
      }
      &.green {
        background: #28A745;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
     .cell{
       //min-height: 40px;
       line-height: 18px;
       position: relative;
       height: inherit;
       //margin-left: 10px;
       //margin-right: 10px;
       padding: 0;
       //padding: 5px 10px;
       //position: absolute;
       //top: 10px;
     }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
</style>
